import * as React from 'react';

function SvgHamburgerMenu(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg width="1em" height="1em" viewBox="0 0 16 16" {...props}>
			<path
				fill="currentColor"
				fillRule="evenodd"
				d="M15.077 13.538a.924.924 0 010 1.847H.923a.923.923 0 010-1.847h14.154zm0-6.769a.923.923 0 010 1.846H.923a.923.923 0 110-1.846h14.154zm0-6.769a.923.923 0 110 1.846H.923A.923.923 0 11.923 0h14.154z"
			/>
		</svg>
	);
}

export default SvgHamburgerMenu;
